import { useContext } from 'react';
import { StoryDetailListWrapperContext, StoryDetailListWrapperContextType } from '#advertStory/detail-list-wrapper';

const useStoryDetailListWrapperContext = () => useContext<StoryDetailListWrapperContextType>(
  StoryDetailListWrapperContext,
);

export { useStoryDetailListWrapperContext };
